import * as React from "react";
import Loader from "../loader";

// The loader with some added text below
const Loading = ({ text }: { text: string }) => {
  const hasAnimation = text.endsWith("...");
  return (
    <div className="loading">
      <Loader />
      <h3>
        {hasAnimation ? text.slice(0, text.length - 3) : text}
        {hasAnimation ? (
          <>
            <span className="loading__dot1">.</span>
            <span className="loading__dot2">.</span>
            <span className="loading__dot3">.</span>
          </>
        ) : null}
      </h3>
    </div>
  );
};

export default Loading;
